import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Gateway } from './gateway.entity'

export class GatewaysRepository extends BaseRepository<Gateway> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.paymentApiUrl + '/gateways', token, cache)
    }

    async getOnePublic(gatewayId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/gateways/' + gatewayId + '/public',
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
